<template>
  <div v-if="product">
    <div class="mr-t-15">
      <template>
        <select v-if="Object.keys(product.fnskus).length > 1" :disabled="isDisableEdit" name="fnsku-kbn" v-model="product.fnsku" :id="`fnsku-kbn-select-${product.asin}`" class="form-control" :class="{'bg-no-input': !product.fnsku}" @change="changeFnsku()">
          <option value="">選択してください</option>
          <option v-for="(val, key) in product.fnskus" :key="key" :value="key">{{ val }}</option>
        </select>
        <div v-else-if="Object.keys(product.fnskus).length === 1" class="m-t">
          {{ product.fnsku }}
          <input type="hidden" v-model="product.fnsku">
        </div>
        <div v-else class="m-t">
          {{ product.fnsku }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    isDisableEdit: {
      type: Boolean,
      default: false
    },
    isChangeSku: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getStatusItem () {
      let item = {
        status: 'FNSKUを利用しない',
        class: 'text-gray'
      }
      let yamatoOfferFnskuKbn = this.product.fnskuKbn
      if (yamatoOfferFnskuKbn) {
        item.status = 'FNSKUを利用する'
        item.class = 'text-red'
      }
      return item
    }
  },
  methods: {
    changeFnsku () {
      if (this.isChangeSku) {
        this.product.sku = this.product.skus[this.product.fnsku]
      }
      this.$emit('update', this.product)
    }
  }
}
</script>
<style scoped>
.bg-no-input {
  color: red;
}
select option {
  color: #000;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/FnskuKbnItem.vue